export default __webpack_public_path__ + "static/media/appcelerator.b74becf5.svg";